// extracted by mini-css-extract-plugin
export var container = "_di-0";
export var content = "_di-3";
export var customerTitle = "_di-4";
export var empty = "_di-5";
export var gray = "_di-6";
export var header = "_di-7";
export var info = "_di-8";
export var loading = "_di-2";
export var loadingCard = "_di-9";
export var oneLine = "_di-a";
export var personName = "_di-e";
export var pillContainer = "_di-b";
export var selected = "_di-1";
export var text = "_di-c";
export var twoLines = "_di-d";
export var unread = "_di-f";
export var unreadIndicator = "_di-g";